import { Box, InputAdornment, TextField } from "@mui/material";
import type { JSX } from "react";

/**
 * Material-style search field — fully rounded, leading magnifier icon.
 * Commits on Enter so the URL doesn't churn on every keystroke. Extracted from
 * `TicketListPage.tsx`.
 */
export function SearchInput({
  value,
  onCommit,
  placeholder,
}: {
  value: string;
  onCommit: (v: string) => void;
  placeholder: string;
}): JSX.Element {
  return (
    <TextField
      type="search"
      defaultValue={value}
      placeholder={placeholder}
      onKeyDown={(e) => {
        if (e.key === "Enter") onCommit((e.target as HTMLInputElement).value);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Box component="svg" viewBox="0 0 16 16" aria-hidden sx={{ height: 16, width: 16, color: "text.disabled" }}>
              <path d="M11 11l3 3M7 12a5 5 0 100-10 5 5 0 000 10z" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
            </Box>
          </InputAdornment>
        ),
      }}
      sx={{ "& .MuiOutlinedInput-root": { borderRadius: 999, bgcolor: "surfaceSoft" } }}
    />
  );
}
